<template>
  <div class="plr15" style="padding-top: 20px">404</div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/view/NotFound.vue